import { createSelector } from '@app/utils/createSelector'
import { replaceOrAppend } from '@app/utils/replaceOrAppend'

import type { ApiSavedAnnouncementSearch } from '@app/packages/api/v2/types/entities'

import { createReduxSlice } from '@app/store/redux_slice'

const savedAnnouncementSearchesSlice = createReduxSlice<ApiSavedAnnouncementSearch[]>('saved_announcement_searches')

export const setSavedAnnouncementSearchesSlice = (list: ApiSavedAnnouncementSearch[]) => savedAnnouncementSearchesSlice.set(list)

export const upsertSavedAnnouncementSearchSlice = (search: ApiSavedAnnouncementSearch) =>
  savedAnnouncementSearchesSlice.update(state => replaceOrAppend(state ?? EMPTY_LIST, search, item => item.id === search.id))

export const removeSavedAnnouncementSearchSlice = (id: string) =>
  savedAnnouncementSearchesSlice.update(state => (state ?? EMPTY_LIST).filter(item => item.id !== id))

export const savedAnnouncementSearchesListSelector = createSelector([savedAnnouncementSearchesSlice.selector], list => list ?? EMPTY_LIST)

export const createSavedAnnouncementSearchSelector = (id: string) =>
  createSelector([savedAnnouncementSearchesListSelector], list => list.find(item => item.id === id))

const EMPTY_LIST: ApiSavedAnnouncementSearch[] = []
